import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import { AddFirmwareState } from './useAddFirmware';

/** Who receives the firmware (one client or everyone), its notes, and whether it is live. */
export const FirmwareDeploymentSection: React.FC<{ state: AddFirmwareState }> = ({ state }) => {
  const { t } = useI18n();
  const { form, submitting, clients } = state;

  return (
    <div className="device-section">
      <h3 className="section-title">{t('otaUpdates.deploymentOptions')}</h3>
      <div className="deployment-fields">
        <div className="form-field">
          <label>{t('clients.client')}</label>
          <select value={form.client_id} onChange={(e) => state.setField('client_id', e.target.value)} disabled={submitting} className="field-select">
            <option value="">{t('otaUpdates.anyClientGlobal')}</option>
            {clients.map((client) => <option key={client.id} value={client.id}>{client.name}</option>)}
          </select>
          <span className="field-hint">{t('otaUpdates.leaveEmptyAllClients')}</span>
        </div>

        <div className="form-field form-field-full">
          <label>{t('otaUpdates.changelog')}</label>
          <textarea
            value={form.changelog}
            onChange={(e) => state.setField('changelog', e.target.value)}
            placeholder={t('otaUpdates.changelogPlaceholder')}
            disabled={submitting}
            className="field-textarea"
            rows={3}
            maxLength={1000}
          />
        </div>

        <div className="form-field form-field-full">
          <label className="checkbox-label">
            <input
              type="checkbox"
              data-testid="field-firmware-is-active"
              checked={form.is_active}
              onChange={(e) => state.setField('is_active', e.target.checked)}
              disabled={submitting}
            />
            <span>{t('otaUpdates.activeForOta')}</span>
          </label>
        </div>
      </div>
    </div>
  );
};
